<template lang="pug">
div
	h1 {{contentpage.name}}
	ws-content(:value="contentpage.content")
		v-row
			v-col.mb-4(cols="4" xs="6" sm="6" md="4" v-for="item in videos" :key="`${item.area.id}-${item.video.videoId}`")
					magic-nuxt-link(:to="item.area")
						v-img.play-btn(:src="item.video.thumb" :ratio="16/9" height="154")
						h3.mt-2.mb-0 {{item.area.name}}

</template>

<style lang="scss">
.play-btn:after {
	background: rgba(22, 25, 39, 0.2)
		url('https://static.wintersport.nl/images/video-play.png') no-repeat 50%; // static.wintersport.nl/images/video-play.png) no-repeat 50%;
	background-size: 20%;
}
</style>
<script>
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import Content from '@dengl/common/components/content.vue';
import { interpolateFields } from '@/utils/interpolate.js';

const query = gql`
	query getVideosByCountry($path: String!, $country: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		country(slug: $country) {
			id
			name
		}
		videos: areaVideosByCountry(slug: $country) {
			area {
				id
				name
				slug
			}
			video {
				thumb
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	name: 'VideosCountry',
	nuxtI18n: {
		paths: {
			'nl-NL': '/videos/land/:country',
			'nl-BE': '/videos/land/:country'
		}
	},
	asyncData({ params, app, error, route }) {
		return app.$graphClient
			.query({
				query,
				variables: {
					path: route.path,
					country: params.country
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				if (!data.contentpage.name) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				const interpolater = interpolateFields({
					find: '{country}',
					replace: data.country.name
				});

				interpolater(data.contentpage.meta, ['title']);
				interpolater(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({ sidebar: { visible: true } });
				app.breadcrumbs({
					[app.i18n.t('page.videos:breadcrumb')]: { name: 'videos' },
					[data.country.name]: {
						name: 'videos-country',
						params: { country: params.country }
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'videos-country-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
